var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container -scrollable text"},[_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.iframeShow),expression:"iframeShow"}],ref:"iframe",staticClass:"iframe",attrs:{"id":"iframe","frameborder":"0","scrolling":"auto","src":_vm.iframeSrc,"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }